export default __webpack_public_path__ + "static/lg-mask-free-image-697122029a3ccdd6e24636a3bdb82885.png";